import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { Form } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import { Alert, Button, Dropdown, Input } from '../../../../UI/Common';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import ReactSelect from '../../../../UI/ReactSelect';

const NewGroupPage = (props) => {
  //prettier-ignore
  const { t, isSubmitting, maps, departments, initDeptId, initDeptName, } = props;
  const form = {
    areaId: '',
    areaIdText: '',
    name: '',
    shortName: '',
    description: '',
    mapPageId: '',
    calculatedValueHeading: 'Calculated Value',
    resendTimeoutMin: 30,
    escalationTimeoutMin: 10,
    departmentId: '',
    departmentIdText: '',
    uncorrectedMessageTemplate:
      '%A remains at %N in %L at %G. Current %P is %V %U. Detected at %T.',
    normalMessageTemplate:
      '%A detected at %N in %L at %G. Current %P is %V %U. Detected at %T.',
    statisticsReportHeading: 'Statistics',
  };
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onCreateGroup(values);
    }
  }
  return (
    <Backend>
      <div className="content-inner">
        <div className="row">
          <div className="col">
            <Formik
              enableReinitialize
              initialValues={{
                ...form,
                departmentId: initDeptId.toString(),
                departmentIdText: initDeptName,
              }}
              validationSchema={validationSchema}
              onSubmit={(values) => onSubmit(values)}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                setFieldValue,
                touched,
                handleSubmit,
              }) => {
                return (
                  <Form>
                    <PasswordConfirmation
                      isOpen={openModal}
                      onCancel={() => setOpenModal(false)}
                      onConfirm={() => {
                        setOpenModal(false);
                        props.onCreateGroup(values);
                      }}
                    />
                    <ReactSelect
                      required
                      isClearable={false}
                      label="Department"
                      options={departments}
                      defaultValue={values.departmentId}
                      value={values.departmentId}
                      valueKey="id"
                      labelKey="name"
                      onChange={(obj) => {
                        setFieldValue('departmentId', obj.value);
                        setFieldValue('mapPageId', '');
                        props.onChangeDept(obj.value ? obj.value : initDeptId);
                      }}
                      invalid={touched.departmentId}
                      error={errors.departmentId}
                    />
                    <Input
                      required
                      id="name"
                      label="Group Name"
                      onChange={handleChange('name')}
                      value={values.name}
                      invalid={touched.name}
                      error={errors.name}
                    />
                    <Input
                      required
                      id="shortName"
                      label="Group Short Name"
                      onChange={handleChange('shortName')}
                      value={values.shortName}
                      invalid={touched.shortName}
                      error={errors.shortName}
                    />
                    <ReactSelect
                      label="Map Page"
                      options={maps}
                      value={values.mapPageId}
                      onChange={(obj) => {
                        setFieldValue('mapPageId', obj.value);
                      }}
                    />
                    <h1 style={{ fontSize: 16, margin: '20px 0px' }}>
                      {t('Notification Settings')}
                    </h1>
                    <div style={{ paddingLeft: 20 }}>
                      <Input
                        required
                        id="normalMessageTemplate"
                        label="Normal Message Template"
                        onChange={handleChange('normalMessageTemplate')}
                        value={values.normalMessageTemplate}
                        invalid={touched.normalMessageTemplate}
                        error={errors.normalMessageTemplate}
                      />
                      <Input
                        required
                        id="uncorrectedMessageTemplate"
                        label="Uncorrected Message Template"
                        onChange={handleChange('uncorrectedMessageTemplate')}
                        value={values.uncorrectedMessageTemplate}
                        invalid={touched.uncorrectedMessageTemplate}
                        error={errors.uncorrectedMessageTemplate}
                      />
                      <Input
                        required
                        id="escalationTimeoutMin"
                        label="Escalation Timeout (Min.)"
                        onChange={handleChange('escalationTimeoutMin')}
                        value={values.escalationTimeoutMin}
                        invalid={touched.escalationTimeoutMin}
                        error={errors.escalationTimeoutMin}
                      />
                      <Input
                        required
                        id="resendTimeoutMin"
                        label="Resend Timeout (Min.)"
                        onChange={handleChange('resendTimeoutMin')}
                        value={values.resendTimeoutMin}
                        invalid={touched.resendTimeoutMin}
                        error={errors.resendTimeoutMin}
                      />
                    </div>
                    <h1 style={{ fontSize: 16, margin: '20px 0px' }}>
                      {t('Statistics Report Settings')}
                    </h1>
                    <div style={{ paddingLeft: 20 }}>
                      <Input
                        id="statisticsReportHeading"
                        label="Statistics Report Heading"
                        onChange={handleChange('statisticsReportHeading')}
                        value={values.statisticsReportHeading}
                        invalid={touched.statisticsReportHeading}
                        error={errors.statisticsReportHeading}
                      />
                      <Input
                        id="calculatedValueHeading"
                        label="Calculated Value Heading"
                        onChange={handleChange('calculatedValueHeading')}
                        value={values.calculatedValueHeading}
                        invalid={touched.calculatedValueHeading}
                        error={errors.calculatedValueHeading}
                      />
                    </div>
                    <Alert.Error text={props.errors} />
                    <Button
                      id="create-group-btn"
                      classes="mt-20"
                      loading={isSubmitting}
                      onClick={handleSubmit}
                    >
                      <i className="md-icon">done</i>
                      {t('Create')}
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div className="col" />
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(NewGroupPage);
